import { render } from "./HeaderLight.vue?vue&type=template&id=396f582e"
import script from "./HeaderLight.vue?vue&type=script&lang=js"
export * from "./HeaderLight.vue?vue&type=script&lang=js"

import "./HeaderLight.vue?vue&type=style&index=0&id=396f582e&lang=scss"
script.render = render

export default script